import styled from 'styled-components';

export const Tracker = styled.div`
  @media screen and (min-width: 1440px) {
    display: flex;
    justify-content: center;
    width: 1014px;
    margin: auto;
    // gap: 81px;
  }
`;
